import { EventEmitter, Injectable } from "@angular/core";

@Injectable()
export class NavigationChangeService {
  navigationChanged = new EventEmitter<any>();
  updateNav = new EventEmitter<any>();
}
